import { FC } from 'react'
import { List } from 'antd'
import { Path, CaretDown } from '@phosphor-icons/react'
import Product, { IProduct } from './product'
import DropdownAction from './dropdown-action'
import { useTranslation } from 'react-i18next'

interface ListProductsWithDropdownProps {
  products: IProduct[]
  optionsDropdown: { id: string; name: string }[]
  hanleMoveProduct: (storeId: string, productId: string) => void
  hanleSelect?: (value: string) => void
  hanleDelete?: (value: string) => void
}

const ListProductsWithDropdown: FC<ListProductsWithDropdownProps> = ({
  products,
  optionsDropdown,
  hanleSelect,
  hanleDelete,
  hanleMoveProduct
}) => {
  const { t } = useTranslation()
  return (
    <List
      itemLayout='horizontal'
      dataSource={products}
      renderItem={(product) => (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <Product product={product} hanleDelete={hanleDelete} hanleSelect={hanleSelect} />
          <DropdownAction
            title={t('multistop.change-stop')}
            iconStart={<Path />}
            iconEnd={<CaretDown />}
            options={optionsDropdown}
            handleOnClick={(storeId) => hanleMoveProduct(storeId, product.id)}
            disabled={optionsDropdown?.length === 0}
          />
        </div>
      )}
    />
  )
}

export default ListProductsWithDropdown
